module.exports = __webpack_public_path__ + "static/product-f0071b81fcbec6a65b50d49bf603f63c.jpg";